import classes from "../ServicesTable.module.scss"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LoginIcon from '@mui/icons-material/Login';
import StartIcon from '@mui/icons-material/Start';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useContext, useEffect, useState } from "react";
import { Container, Row , Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { TextField } from "../../integrationWizard/form/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { servicesEditFields } from "./servicesColumns";
import ServiceForm from "./ServiceForm";
import { OrgIdContext } from "../../../store/orgId_context";
import EditOffIcon from '@mui/icons-material/EditOff';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CircleIcon from '@mui/icons-material/Circle';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { t } from "i18next";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useTranslation } from "react-i18next";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import GenericModal from "../../UI/GenericModal";
import { GenericTooltip } from "../../integrationWizard/form/GenericTooltip";
import Button from "../../UI/Button";
import { DDD } from "../../../lib/ddd/ddd";
import LoadingDots from "../../UI/LoadingDots";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ServicesTableTrActivate = ({data:inputData, index, tableInfo, orgData, onSubmit, master}) => {
    const [editable, setEditable] = useState();
    const [hasFields, setHasFields] = useState(false);
    const [data, setData] = useState({})
    const { isMaintainer } = useContext(OrgIdContext);
    const { t } = useTranslation();
    const [showNewWindow, setShowNewWindow] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const [showForm, setShowForm] = useState(false);
    const {
            register,
            reset,
            formState: { errors },
            handleSubmit,
            control,
            setValue,
            getValues,
    } = useForm();

    const onCreateNewDeviceClick = () =>{
        setShowNewWindow(true);
    }

    const onTrClick = () =>{
        /*if(!editable)
            return;*/
        if(!hasFields)
            return;
        setShowForm(prev => !prev);
    }
//{"method":"Extension.Execute","params":{"extension":"EUeInvoices.CreateMailAndPackageForAction","args":{"Mail":"eracunicrnagoradoo1"}},"id":68123233}
    const createDeviceSubmit = (data) =>{
        console.log(data);
        if(!data.InternalName || data.InternalName.trim() === ""){
            _setError(t("Please enter a valid email"));
            return;
        }
        if(!/^[A-Za-z0-9._%+-]+$/.test(data.InternalName)){
            _setError(t("Please enter a valid email prefix without special characters or domain"));
            return;
        }
        if(data.InternalName.length > 64){
            _setError(t("Email prefix is too long. Maximum length is 64 characters."));
            return;
        }
        if(data.InternalName.includes("@")){
            _setError(t("Please enter only the email prefix, without the domain part."));
            return;
        }
        if(data.InternalName.trim().length < 4){
            _setError(t("Email prefix is too short. Minimum length is 4 characters."));
            return;
        }
        const ddd = new DDD(apiRequestAddress);
        setLoading(true);
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateMailAndPackageForAction", {Mail: data.InternalName.trim()}).then((res)=>{
            setLoading(false);
            if(res?.result?.Status === "Error"){
                _setError(res?.result?.Reason || t("An error occurred while creating the email"));
                return;
            }
            onSubmit&&onSubmit();
            setShowNewWindow(false);
        });
    }

    const _setError = (msg) =>{
        setError(msg);
        setTimeout(() => {
            setError(null);
        }, 8000);
    }
    
    return (
    <>
        <Container className={`${classes["rowContainer"]} g-0`} style={index%2===0 ? {backgroundColor:"#f1f5fd"} : {backgroundColor:"#f9fbff"}}>
            <Row  className={`${classes["tableRow"]} g-0`} onClick={onTrClick} style={hasFields ? {cursor:"pointer"} : {}}>
                <Col className={`col-1 ${classes["trcol"]}`}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{t("Auto-generate an e-mail to which you will forward you received invoices")}</Tooltip>}>
                        <i className={classes["stepCircle"]}>86</i>
                    </OverlayTrigger>
                </Col> 
                <Col className={`col-7 ${classes["trcol"]}`} style={{textAlign:"left", paddingLeft:"1rem", fontWeight:"bold"}}>MailReceivedSlurp</Col>
                <Col className={`col-2 ${classes["trcol"]}`}>eInvoice</Col>
                <Col className={`col-2 ${classes["trcollast"]}`} style={{textAlign:"right", paddingRight:"1rem"}}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{t("Create an email to which you will forward your received invoices which will be automatically read by our services. More detailed instructions inside, once the channel is created.")}</Tooltip>}>
                        <button className={classes.generateBtn} onClick={onCreateNewDeviceClick}>
                            <AddCircleIcon className={classes.icon} />
                            <span className={classes.text}>{t("Generate")}</span>
                        </button>
                    </OverlayTrigger>
                </Col>
            </Row>
            <GenericModal show={showNewWindow} onHide={() => setShowNewWindow(null)} title={t("Enter email")}>
                <form className={classes["input-container"]} onSubmit={handleSubmit(createDeviceSubmit)}>
                    <div className="w-100">
                        <div key={"InternalName"} className={`${classes["input-group"]} mt-1`}>
                            <label>
                            {t("Enter email")}<span className="text-danger">*</span>
                            <GenericTooltip tooltip={t("Enter an email to which you will forward your received invoices which will be automatically read by our services. More detailed instructions follow once the channel is created.")} fieldName={"InternalName"} placement="top" />
                            </label>
                            <div className={classes["email-input-wrapper"]}>
                            <input
                                {...register("InternalName", { required: true })}
                                type="text"
                                className={classes["email-input"]}
                            />
                            <span className={classes["email-domain"]}>@rei-dddinvoices.com</span>
                            </div>
                            {errors["InternalName"] && (
                            <span className="text-danger mt-1">{t("This field is required")}</span>
                            )}
                        </div>
                        {error && <div className="text-danger mt-2">{error}</div>}
                        <hr/>
                    </div>
                    <div className="text-center w-100">
                        {loading ? <LoadingDots/> : <Button type="submit" className="px-5 py-1 ms-3" >
                            {t("Create")}
                        </Button>}
                    </div>
                </form>
            </GenericModal>
        </Container>
    </>
    )
}

export default ServicesTableTrActivate;